class ExternalAssetsData {

    constructor() {

        this._sortByPopularity = true;
        this._cataloguePage = 0;
        this._catalogueTopics = null;
        this._cataloguePhotos = null;
        this._searchByTopic = false;
        this._searchByTerm = false;
        this._numberOfSuggestions = 3;
        this._documentType = null;
        this._suggestionsTerm = "";

    }

    getSuggestionsTerm() {
        return this._suggestionsTerm;
    }

    getDocumentType() {
        return this._documentType;
    }

    getNumberOfSuggestions() {
        return this._numberOfSuggestions;
    }

    getCurrentPage() {
        return this._cataloguePage;
    }

    getIsSearchByTopic() {
        return this._searchByTopic;
    }

    getIsSearchByTerm() {
        return this._searchByTerm;
    }

    getIsSortedByPopularity() {
        return this._sortByPopularity;
    }

    getCatalogueTopics() {
        return this._catalogueTopics;
    }

    getCataloguePhotos() {
        return this._cataloguePhotos;
    }

    setSuggestionsTerm(suggestionsTerm) {
        this._suggestionsTerm = suggestionsTerm;
    }

    setSearchByTopic(searchByTopic) {
        this._searchByTopic = searchByTopic;
    }

    setSearchByTerm(searchByTerm) {
        this._searchByTerm = searchByTerm;
    }

    setPage(page) {
        this._cataloguePage = page;
    }

    setCatalogueTopics(topics) {
        this._catalogueTopics = topics;
    }

    setCataloguePhotos(photos) {
        this._cataloguePhotos = photos;
    }

    setDocumentType(documentType) {
        this._documentType = documentType;
    }

    addCataloguePhotos(photos) {
        this._cataloguePhotos = _.concat(this._cataloguePhotos, photos);
    }

    clearData() {

        this._sortByPopularity = true;
        this._cataloguePage = 0;
        this._catalogueTopics = null;
        this._cataloguePhotos = null;
        this._searchByTopic = false;
        this._searchByTerm = false;
        this._numberOfSuggestions = 3;
        this._documentType = null;
        this._suggestionsTerm = "";

    }

}